module.exports = __webpack_public_path__ + "img/knight4cf_05.91d4cae0.jpg";